import { render, staticRenderFns } from "./ValueWIndicator.vue?vue&type=template&id=ab45d964&"
import script from "./ValueWIndicator.vue?vue&type=script&lang=js&"
export * from "./ValueWIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports